import type { ExerciseCatalogEntry } from '../types';

export const normalizeExerciseName = (name: string): string => {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
};

export function filterCatalog(
  catalog: ExerciseCatalogEntry[],
  query: string,
  muscles: string[],
  equipment: string[]
): ExerciseCatalogEntry[] {
  let results = query.trim()
    ? catalog.filter(e => e.normalized_name.includes(normalizeExerciseName(query)))
    : catalog;
  if (muscles.length > 0)
    results = results.filter(e =>
      muscles.some(m => e.primary_muscles?.includes(m)));
  if (equipment.length > 0)
    results = results.filter(e => e.equipment != null && equipment.includes(e.equipment));
  return results;
}

export const findCatalogMatch = (
  catalog: ExerciseCatalogEntry[],
  name: string,
  userId?: string
): ExerciseCatalogEntry | null => {
  const normalized = normalizeExerciseName(name);
  const matches = catalog.filter(
    (entry) => entry.normalized_name === normalized
  );

  if (userId) {
    const userMatch = matches.find((entry) => entry.owner_user_id === userId);
    if (userMatch) return userMatch;
  }

  return matches.find((entry) => entry.owner_user_id === null) || matches[0] || null;
};
